import axios from "../axios/axios";

export type GalenCardStatus = "ACTIVE" | "INACTIVE" | "PREACTIVATED";

export interface GalenLoyaltyCard {
  id: number;
  cardCode: string;
  cardStatus: GalenCardStatus;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  mobile: string;
  joinedDate: string;
  created: string;
  regularPointsBalance: number;
  bonusPointsBalance: number;
  invoiceCount: number;
  invoiceTotal: number;
}

export interface GalenLoyaltyPage {
  elements: GalenLoyaltyCard[];
  pageNum: number;
  totalNumOfPages: number;
  totalNumOfElements: number;
}

export const getBranchLoyaltyCards = async (
  branchMarketplaceId: number,
  params: {
    from?: string;
    to?: string;
    status?: GalenCardStatus;
    search?: string;
    page?: number;
    size?: number;
    sort?: string;
  } = {}
): Promise<GalenLoyaltyPage> => {
  const res = await axios.get<GalenLoyaltyPage>(
    `/user_loyalty_card/branch_marketplace_id/${branchMarketplaceId}/galen`,
    { params }
  );
  return res.data;
};
